(function () {
  'use strict';

  function cartRoute(path) {
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return base.replace(/\/$/, '') + path;
  }

  function initPromo(root) {
    var btn = root.querySelector('[data-tcb-apply-promo]');
    var input = root.querySelector('#tcb-cart-promo-input');
    var message = root.querySelector('[data-tcb-promo-message]');
    if (!btn || !input) return;
    btn.addEventListener('click', function () {
      var code = String(input.value || '').trim();
      if (!code) return;
      if (message) {
        message.hidden = false;
        message.textContent = 'Redirecting to apply code…';
      }
      window.location.href = cartRoute('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cartRoute('/cart')));
    });
  }

  function initSaveForLater(root) {
    root.querySelectorAll('[data-tcb-save-for-later]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-product-url');
        var title = btn.getAttribute('data-product-title') || 'Product';
        if (!url) return;
        try {
          var key = 'tcb_saved_for_later';
          var list = JSON.parse(localStorage.getItem(key) || '[]');
          if (!list.some(function (item) { return item.url === url; })) {
            list.unshift({ url: url, title: title, savedAt: Date.now() });
            localStorage.setItem(key, JSON.stringify(list.slice(0, 20)));
          }
          btn.textContent = 'Saved';
          btn.disabled = true;
          renderSavedForLater(root);
        } catch (e) { /* ignore */ }
      });
    });
    renderSavedForLater(root);
  }

  function readSavedForLater() {
    try {
      return JSON.parse(localStorage.getItem('tcb_saved_for_later') || '[]');
    } catch (e) {
      return [];
    }
  }

  function writeSavedForLater(list) {
    try {
      localStorage.setItem('tcb_saved_for_later', JSON.stringify(list.slice(0, 20)));
    } catch (e) { /* ignore */ }
  }


  function isSafeCartUrl(url) {
    return typeof url === 'string' && /^\/(products|collections|pages|cart|blogs|policies|account)(\/|$)/.test(url);
  }

  function renderSavedForLater(root) {
    var section = root.querySelector('[data-tcb-cart-saved]');
    var listEl = root.querySelector('[data-tcb-saved-list]');
    var countEl = root.querySelector('[data-tcb-saved-count]');
    if (!section || !listEl) return;

    var items = readSavedForLater().filter(function (item) {
      return item && isSafeCartUrl(item.url) && item.title;
    });
    listEl.textContent = '';
    if (!items.length) {
      section.hidden = true;
      if (countEl) countEl.textContent = '(0)';
      return;
    }

    section.hidden = false;
    if (countEl) countEl.textContent = '(' + items.length + ')';

    items.forEach(function (item, index) {
      var li = document.createElement('li');
      li.className = 'tcb-cart-saved__item';

      var link = document.createElement('a');
      link.href = item.url;
      link.textContent = item.title;
      li.appendChild(link);

      var actions = document.createElement('div');
      actions.className = 'tcb-cart-saved__actions';

      var moveBtn = document.createElement('button');
      moveBtn.type = 'button';
      moveBtn.className = 'tcb-cart-saved__move';
      moveBtn.setAttribute('data-tcb-saved-move', '');
      moveBtn.setAttribute('data-index', String(index));
      moveBtn.textContent = 'Move to Cart';
      actions.appendChild(moveBtn);

      var removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'tcb-cart-saved__remove';
      removeBtn.setAttribute('data-tcb-saved-remove', '');
      removeBtn.setAttribute('data-index', String(index));
      removeBtn.setAttribute('aria-label', 'Remove saved item');
      removeBtn.textContent = 'Remove';
      actions.appendChild(removeBtn);

      li.appendChild(actions);
      listEl.appendChild(li);
    });

    listEl.querySelectorAll('[data-tcb-saved-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = Number(btn.getAttribute('data-index'));
        var list = readSavedForLater();
        list.splice(idx, 1);
        writeSavedForLater(list);
        renderSavedForLater(root);
      });
    });

    listEl.querySelectorAll('[data-tcb-saved-move]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = Number(btn.getAttribute('data-index'));
        var list = readSavedForLater();
        var item = list[idx];
        if (!item || !isSafeCartUrl(item.url)) return;
        window.location.href = item.url;
      });
    });
  }

  function initSaveCartForLater(root) {
    root.querySelectorAll('[data-tcb-save-cart-for-later]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var rows = root.querySelectorAll('[data-tcb-cart-line]');
        var key = 'tcb_saved_for_later';
        var list = readSavedForLater();
        rows.forEach(function (row) {
          var titleEl = row.querySelector('.tcb-cart-row__title');
          var linkEl = row.querySelector('.tcb-cart-row__title[href], .tcb-cart-row__image');
          var url = linkEl ? linkEl.getAttribute('href') : '';
          var title = titleEl ? titleEl.textContent.trim() : 'Product';
          if (!url || list.some(function (item) { return item.url === url; })) return;
          list.unshift({ url: url, title: title, savedAt: Date.now() });
        });
        writeSavedForLater(list);
        renderSavedForLater(root);
        btn.textContent = 'Saved to list';
        btn.disabled = true;
      });
    });
  }

  function initRemoveSelected(root) {
    root.querySelectorAll('[data-tcb-remove-selected]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var selected = typeof root.__tcbGetSelectedRows === 'function' ? root.__tcbGetSelectedRows() : [];
        if (!selected.length) return;
        if (!window.confirm('Remove selected items from your cart?')) return;

        var updates = {};
        selected.forEach(function (row) {
          var key = row.getAttribute('data-line-key');
          if (key) updates[key] = 0;
        });

        fetch(cartRoute('/cart/update.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (r) {
          if (!r.ok) throw new Error('update failed');
          window.location.reload();
        }).catch(function () { /* ignore */ });
      });
    });
  }

  function syncShippingProgress(root, selectedRows) {
    var progress = root.querySelector('[data-tcb-cart-ship-progress]');
    if (!progress) return;

    var threshold = Number(progress.getAttribute('data-threshold-cents') || 9900);
    var partsCents = 0;
    (selectedRows || []).forEach(function (row) {
      if (row.getAttribute('data-needs-freight') === 'true') return;
      partsCents += Number(row.getAttribute('data-line-cents') || 0);
    });

    var remaining = Math.max(0, threshold - partsCents);
    var pct = threshold > 0 ? Math.min(100, Math.round((partsCents / threshold) * 100)) : 0;
    if (pct > 0 && pct < 4) pct = 4;
    var qualified = partsCents >= threshold;
    var messageEl = progress.querySelector('.tcb-cart-ship-progress__message');
    var fillEl = progress.querySelector('[data-tcb-ship-progress-fill]');
    var truckEl = progress.querySelector('[data-tcb-ship-progress-truck]');
    var midMarker = progress.querySelector('.tcb-cart-ship-progress__marker--mid');

    progress.classList.toggle('is-qualified', qualified);
    progress.classList.toggle('is-empty', partsCents === 0);
    if (messageEl) {
      if (qualified) {
        messageEl.textContent = '';
        messageEl.appendChild(document.createTextNode('You qualify for '));
        var strong1 = document.createElement('strong');
        strong1.textContent = 'FREE Parts Shipping!';
        messageEl.appendChild(strong1);
        messageEl.appendChild(document.createTextNode(' Nice choice.'));
      } else if (selectedRows && selectedRows.length) {
        messageEl.textContent = '';
        messageEl.appendChild(document.createTextNode("You're "));
        var strongAmt = document.createElement('strong');
        strongAmt.textContent = formatMoney(remaining);
        messageEl.appendChild(strongAmt);
        messageEl.appendChild(document.createTextNode(' away from '));
        var strongFree = document.createElement('strong');
        strongFree.textContent = 'FREE parts shipping!';
        messageEl.appendChild(strongFree);
      } else {
        messageEl.textContent = '';
        messageEl.appendChild(document.createTextNode('Replacement parts orders over '));
        var strong99 = document.createElement('strong');
        strong99.textContent = '$99';
        messageEl.appendChild(strong99);
        messageEl.appendChild(document.createTextNode(' ship free in the lower 48.'));
      }
    }
    if (fillEl) fillEl.style.width = (qualified ? 100 : pct) + '%';
    if (truckEl) {
      truckEl.style.left = (qualified ? 100 : pct) + '%';
      if (partsCents === 0) truckEl.style.left = '0%';
    }
    if (midMarker) midMarker.hidden = qualified;

    root.querySelectorAll('[data-tcb-cart-line]').forEach(function (row) {
      if (row.getAttribute('data-needs-freight') === 'true') return;
      var banner = row.querySelector('.tcb-cart-row__parts-ship');
      if (banner) {
        banner.hidden = !qualified;
        return;
      }
      if (!qualified) return;
      var meta = row.querySelector('.tcb-cart-row__meta');
      if (!meta || meta.querySelector('.tcb-cart-row__parts-ship')) return;
      var newBanner = document.createElement('p');
      newBanner.className = 'tcb-cart-row__parts-ship';
      newBanner.textContent = 'You qualify for FREE Parts Shipping! Nice choice.';
      var sku = meta.querySelector('.tcb-cart-row__sku');
      if (sku && sku.nextSibling) meta.insertBefore(newBanner, sku.nextSibling);
      else meta.appendChild(newBanner);
    });
  }

  function addVariantsToCart(variantIds) {
    if (!variantIds.length) return Promise.resolve();
    var items = variantIds.map(function (id) { return { id: Number(id), quantity: 1 }; });
    return fetch(cartRoute('/cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    });
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function syncFbtBundle(root) {
    var totalEl = root.querySelector('[data-tcb-fbt-total-value]');
    var addBtn = root.querySelector('[data-tcb-fbt-add-all]');
    var totalCents = 0;
    var selectedCount = 0;

    root.querySelectorAll('.tcb-cart-fbt__card--wireframe').forEach(function (card) {
      var checkbox = card.querySelector('[data-tcb-fbt-select]');
      var included = !!(checkbox && checkbox.checked);
      card.classList.toggle('is-excluded', !included);
      if (included) {
        selectedCount += 1;
        totalCents += Number(card.getAttribute('data-fbt-price-cents') || 0);
      }
    });

    if (totalEl) {
      totalEl.textContent = formatMoney(totalCents);
    }
    if (addBtn) {
      addBtn.disabled = selectedCount === 0;
    }
  }

  function initFbtBundle(root) {
    syncFbtBundle(root);
    root.querySelectorAll('[data-tcb-fbt-select]').forEach(function (checkbox) {
      checkbox.addEventListener('change', function () {
        syncFbtBundle(root);
      });
    });
  }

  function initFbtAddAll(root) {
    var btn = root.querySelector('[data-tcb-fbt-add-all]');
    if (!btn) return;
    initFbtBundle(root);
    btn.addEventListener('click', function () {
      var ids = [];
      root.querySelectorAll('.tcb-cart-fbt__card--wireframe').forEach(function (card) {
        var checkbox = card.querySelector('[data-tcb-fbt-select]');
        if (checkbox && checkbox.checked) {
          var id = card.getAttribute('data-variant-id');
          if (id) ids.push(id);
        }
      });
      if (!ids.length) return;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      addVariantsToCart(ids)
        .then(function () {
          window.location.reload();
        })
        .catch(function () {
          btn.disabled = false;
          btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6h15l-1.5 9h-12L6 6Z" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linejoin="round"/><circle cx="9" cy="20" r="1.5" fill="currentColor"/><circle cx="18" cy="20" r="1.5" fill="currentColor"/><path d="M6 6 5 3H2" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/></svg> Add All to Cart';
          syncFbtBundle(root);
        });
    });
  }

  function initClearCart(root) {
    var link = root.querySelector('[data-tcb-clear-cart]');
    if (!link) return;
    link.addEventListener('click', function (e) {
      if (!window.confirm('Remove all items from your cart?')) {
        e.preventDefault();
      }
    });
  }

  function initCheckoutGate(root) {
    var gate = root.querySelector('[data-tcb-cart-checkout-gate]');
    var checkoutBtn = root.querySelector('[data-tcb-cart-checkout]');
    if (!gate || !checkoutBtn) return;

    function hasSelectedLines() {
      if (typeof root.__tcbGetSelectedRows === 'function') {
        return root.__tcbGetSelectedRows().length > 0;
      }
      return true;
    }

    function needsFreightAck() {
      return gate.getAttribute('data-needs-freight-ack') === 'true';
    }

    function isReady() {
      return hasSelectedLines();
    }

    function sync() {
      checkoutBtn.disabled = !isReady();
      gate.classList.toggle('is-ready', isReady());
      if (isReady()) gate.classList.remove('is-required');
      var mobileCheckout = root.querySelector('[data-tcb-cart-checkout-mobile]');
      if (mobileCheckout) mobileCheckout.disabled = !isReady();
    }

    sync();
    root.__tcbSyncCheckout = sync;

    checkoutBtn.addEventListener('click', function () {
      if (!isReady()) return;

      checkoutBtn.disabled = true;
      checkoutBtn.textContent = 'Processing…';

      var attrs = {
        'Checkout initiated from cart': new Date().toISOString()
      };
      if (needsFreightAck()) {
        attrs['Freight review notice shown'] = 'Quote & Freight Reviewed Before Ship';
      }

      var allRows = root.querySelectorAll('[data-tcb-cart-line]');
      var selectedRows = typeof root.__tcbGetSelectedRows === 'function' ? root.__tcbGetSelectedRows() : Array.from(allRows);
      var partial = selectedRows.length > 0 && selectedRows.length < allRows.length;
      var payload = { attributes: attrs };

      if (partial) {
        var held = [];
        var updates = {};
        allRows.forEach(function (row) {
          var key = row.getAttribute('data-line-key');
          var variantId = row.getAttribute('data-variant-id');
          var qty = Number(row.getAttribute('data-quantity') || 0);
          var cb = row.querySelector('[data-tcb-cart-line-select]');
          var included = !!(cb && cb.checked);
          if (!included && key) {
            if (variantId && qty > 0) held.push({ id: Number(variantId), quantity: qty });
            updates[key] = 0;
          }
        });
        payload.updates = updates;
        if (held.length) {
          try { sessionStorage.setItem('tcb_cart_held', JSON.stringify(held)); } catch (e) { /* ignore */ }
        }
      } else {
        try { sessionStorage.removeItem('tcb_cart_held'); } catch (e) { /* ignore */ }
      }

      fetch(cartRoute('/cart/update.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('update failed');
          window.location.href = cartRoute('/checkout');
        })
        .catch(function () {
          checkoutBtn.disabled = false;
          checkoutBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true"><path d="M7 11V8a5 5 0 0 1 10 0v3" fill="none" stroke="currentColor" stroke-width="2"/><rect x="5" y="11" width="14" height="10" rx="2" fill="none" stroke="currentColor" stroke-width="2"/></svg> Checkout Securely';
        });
    });
  }

  function initLineSelection(root) {
    var rows = root.querySelectorAll('[data-tcb-cart-line]');
    if (!rows.length) return;

    var selectAllInputs = root.querySelectorAll('[data-tcb-cart-select-all]');
    var summarySubtotal = root.querySelector('[data-tcb-summary-subtotal]');
    var summaryEstimated = root.querySelector('[data-tcb-summary-estimated]');
    var summaryCountLabel = root.querySelector('[data-tcb-summary-count-label]');
    var summaryNote = root.querySelector('[data-tcb-summary-note]');
    var gate = root.querySelector('[data-tcb-cart-checkout-gate]');
    var freightNotice = gate ? gate.querySelector('[data-tcb-freight-review-notice]') : null;

    function getSelectedRows() {
      return Array.prototype.filter.call(rows, function (row) {
        var cb = row.querySelector('[data-tcb-cart-line-select]');
        return !!(cb && cb.checked);
      });
    }

    function syncSelectAllState(selectedCount) {
      selectAllInputs.forEach(function (input) {
        input.checked = selectedCount === rows.length;
        input.indeterminate = selectedCount > 0 && selectedCount < rows.length;
      });
    }

    function sync() {
      var selected = getSelectedRows();
      var itemCount = 0;
      var subtotalCents = 0;
      var needsFreight = false;

      selected.forEach(function (row) {
        itemCount += Number(row.getAttribute('data-quantity') || 0);
        subtotalCents += Number(row.getAttribute('data-line-cents') || 0);
        if (row.getAttribute('data-needs-freight') === 'true') needsFreight = true;
      });

      rows.forEach(function (row) {
        var cb = row.querySelector('[data-tcb-cart-line-select]');
        row.classList.toggle('is-deselected', !(cb && cb.checked));
      });

      var countLabel = 'Subtotal (' + itemCount + ' ' + (itemCount === 1 ? 'item' : 'items') + ')';
      if (summarySubtotal) summarySubtotal.textContent = formatMoney(subtotalCents);
      if (summaryEstimated) summaryEstimated.textContent = formatMoney(subtotalCents);
      if (summaryCountLabel) summaryCountLabel.textContent = countLabel;
      if (summaryNote) summaryNote.hidden = selected.length === rows.length;

      root.querySelectorAll('[data-tcb-mobile-summary-estimated]').forEach(function (el) {
        el.textContent = formatMoney(subtotalCents);
      });
      var mobileInline = root.querySelector('[data-tcb-mobile-summary-subtotal-inline]');
      if (mobileInline) mobileInline.textContent = formatMoney(subtotalCents);
      root.querySelectorAll('[data-tcb-mobile-summary-count-label]').forEach(function (el) {
        el.textContent = countLabel;
      });

      if (gate) gate.setAttribute('data-needs-freight-ack', needsFreight ? 'true' : 'false');
      if (freightNotice) freightNotice.hidden = !needsFreight;

      syncSelectAllState(selected.length);
      syncShippingProgress(root, selected);
      if (typeof root.__tcbSyncCheckout === 'function') root.__tcbSyncCheckout();
    }

    rows.forEach(function (row) {
      var cb = row.querySelector('[data-tcb-cart-line-select]');
      if (!cb) return;
      cb.addEventListener('change', sync);
    });

    selectAllInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        rows.forEach(function (row) {
          var cb = row.querySelector('[data-tcb-cart-line-select]');
          if (cb) cb.checked = input.checked;
        });
        sync();
      });
    });

    root.__tcbGetSelectedRows = getSelectedRows;
    sync();
  }

  function initMobileCheckoutBar(root) {
    var mobileBtn = root.querySelector('[data-tcb-cart-checkout-mobile]');
    var checkoutBtn = root.querySelector('[data-tcb-cart-checkout]');
    if (!mobileBtn || !checkoutBtn) return;
    mobileBtn.addEventListener('click', function () {
      if (checkoutBtn.disabled) {
        checkoutBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      checkoutBtn.click();
    });
  }

  function restoreHeldCartLines() {
    var raw;
    try { raw = sessionStorage.getItem('tcb_cart_held'); } catch (e) { return Promise.resolve(); }
    if (!raw) return Promise.resolve();
    var items;
    try { items = JSON.parse(raw); } catch (e) { return Promise.resolve(); }
    if (!items || !items.length) return Promise.resolve();
    try { sessionStorage.removeItem('tcb_cart_held'); } catch (e) { /* ignore */ }
    return fetch(cartRoute('/cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (r.ok) window.location.reload();
    }).catch(function () { /* ignore */ });
  }

  function initMobileShipEstimate(root) {
    var btn = root.querySelector('[data-tcb-mobile-estimate-shipping]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var mobileZip = root.querySelector('#tcb-cart-promo-input-mobile-zip');
      var desktopZip = root.querySelector('#tcb-shipping-estimator-zip');
      var calc = root.querySelector('[data-action="estimate-shipping"]');
      if (mobileZip && desktopZip) desktopZip.value = mobileZip.value;
      if (calc) calc.click();
    });
  }

  function initSection(section) {
    if (!section) return;
    initLineSelection(section);
    initPromo(section);
    initSaveForLater(section);
    initSaveCartForLater(section);
    initRemoveSelected(section);
    initClearCart(section);
    initCheckoutGate(section);
    initMobileCheckoutBar(section);
    initMobileShipEstimate(section);
    section.querySelectorAll('[data-tcb-cart-fbt]').forEach(function (fbt) {
      initFbtAddAll(fbt);
    });
    if (window.TcbCartDrawerInitUpsells) {
      window.TcbCartDrawerInitUpsells(section);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    restoreHeldCartLines().finally(function () {
      document.querySelectorAll('.shopify-section--tcb-cart-page').forEach(initSection);
    });
  });

  document.addEventListener('cart:rerendered', function () {
    document.querySelectorAll('.shopify-section--tcb-cart-page').forEach(initSection);
  });
})();
